import { render, staticRenderFns } from "./HeroComics.vue?vue&type=template&id=6052294e&scoped=true&lang=pug&"
import script from "./HeroComics.vue?vue&type=script&lang=js&"
export * from "./HeroComics.vue?vue&type=script&lang=js&"
import style0 from "./HeroComics.vue?vue&type=style&index=0&id=6052294e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6052294e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VImg,VTooltip})
